import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import css from './ProfileSettingsForm.module.css';
import invoiceCss from '../../components/Invoice/invoice.module.css';
import { ReactComponent as Location } from '../../assets/svg/locationPin.svg';

import classNames from 'classnames';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
import { ReactComponent as Clock } from '../../assets/svg/clock.svg';
import {
  Button,
  FieldDateInput,
  Form,
  IconSpinner,
  InlineTextButton,
  JobListingAppliedCard,
  Logo,
  Modal,
  NamedLink,
  PaginationLinks,
} from '../../components';
import { Form as FinalForm } from 'react-final-form';
import moment from 'moment';
import { parse } from 'url';
import {
  earningFetchType,
  gstNumber,
  languageSelectOptions,
  qstNumber,
  workerDashboardTab,
} from '../../marketplace-custom-config';
import { formatMoney, unitDivisor } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import config from '../../config';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { ensureListing } from '../../util/data';
import { createSlug } from '../../util/urlHelpers';
const textfield = 'textfield';
const errorTextField = 'errorTextField';

const { Money } = sdkTypes;

function WorkerDashboardForm(props) {
  const {
    history,
    searchParams,
    params,
    tab,
    intl,
    userNativeLang,
    workerData,
    workingStaffs,
    pagination,
    onfetchEarning,
    fetchInProgress,
    workerEarnings,
    workerJobs,
    workerJobsPagination,
    onManageDisableScrolling,
    currentUser,
    jobCategoryOptions,
    jobSubCategoryOptions,
  } = props;

  // const [earningTabSelected, setEarningTabSelected] = useState(
  //   searchParams?.box || earningFetchType.lastWeek
  // );
  const [downloading, setDownloading] = useState(false);

  const earningTabSelected = searchParams?.box || earningFetchType.lastWeek;
  const fromToDatePlaceholder = intl.formatMessage({
    id: 'WorkerDashboardForm.fromToDatePlaceholder',
  });
  const fromDateLabel = intl.formatMessage({
    id: 'WorkerDashboardForm.fromDateLabel',
  });
  const toDateLabel = intl.formatMessage({
    id: 'WorkerDashboardForm.toDateLabel',
  });

  let currentDate = moment();

  let endDateAndTime;
  let StartDateAndTime;

  // const filteredListingDate = workingStaffs?.filter(w => {
  //   let startTimeHour =
  //     w?.listing?.attributes?.publicData?.scheduleType === 'oneTime'
  //       ? parseInt(
  //           w?.listing?.attributes?.publicData?.oneTimeScheduleList?.[0]?.startTime?.hours?.value
  //         )
  //       : parseInt(
  //           w?.listing?.attributes?.publicData?.recurringScheduleList?.[0]?.startTime?.hours?.value
  //         );

  //   let startTimeMinute =
  //     w?.listing?.attributes?.publicData?.scheduleType === 'oneTime'
  //       ? parseInt(
  //           w?.listing?.attributes?.publicData?.oneTimeScheduleList?.[0]?.startTime?.min?.value
  //         )
  //       : parseInt(
  //           w?.listing?.attributes?.publicData?.recurringScheduleList?.[0]?.startTime?.min?.value
  //         );

  //   let endTimeHour =
  //     w?.listing?.attributes?.publicData?.scheduleType === 'oneTime'
  //       ? parseInt(
  //           w?.listing?.attributes?.publicData?.oneTimeScheduleList?.[0]?.endTime?.hours?.value
  //         )
  //       : parseInt(
  //           w?.listing?.attributes?.publicData?.recurringScheduleList?.[0]?.endTime?.hours?.value
  //         );
  //   let endTimeMinutes =
  //     w?.listing?.attributes?.publicData?.scheduleType === 'oneTime'
  //       ? parseInt(
  //           w?.listing?.attributes?.publicData?.oneTimeScheduleList?.[0]?.endTime?.min?.value
  //         )
  //       : parseInt(
  //           w?.listing?.attributes?.publicData?.recurringScheduleList?.[0]?.endTime?.min?.value
  //         );
  //   let startDate =
  //     w?.listing?.attributes?.publicData?.scheduleType === 'oneTime'
  //       ? w?.listing?.attributes?.publicData?.oneTimeScheduleList?.[0]?.startDate?.date
  //       : w?.listing?.attributes?.publicData?.recurringScheduleList?.[0]?.startDate?.date;
  //   let endDate =
  //     w?.listing?.attributes?.publicData?.scheduleType === 'oneTime'
  //       ? w?.listing?.attributes?.publicData?.oneTimeScheduleList?.[0]?.startDate?.date
  //       : w?.listing?.attributes?.publicData?.recurringScheduleList?.[0]?.endDate?.date;
  //   StartDateAndTime = moment(startDate).set({
  //     hours: startTimeHour,
  //     minutes: startTimeMinute,
  //   });
  //   endDateAndTime = moment(endDate).set({
  //     hours: endTimeHour,
  //     minutes: endTimeMinutes,
  //   });

  //   if (StartDateAndTime > endDateAndTime) {
  //     endDateAndTime.add(1, 'day');
  //   }

  //   if (
  //     tab === workerDashboardTab.upcomingShifts
  //     // && currentDate.isBefore(StartDateAndTime)
  //   ) {
  //     return currentDate.isBefore(StartDateAndTime);
  //   } else if (
  //     tab === workerDashboardTab.currentShifts
  //     // &&
  //     // currentDate.isSameOrAfter(StartDateAndTime) &&
  //     // currentDate.isSameOrBefore(endDateAndTime)
  //   ) {
  //     return (
  //       currentDate.isSameOrAfter(StartDateAndTime) && currentDate.isSameOrBefore(endDateAndTime)
  //     );
  //   } else if (tab === workerDashboardTab.pastShifts) {
  //     return currentDate.isAfter(endDateAndTime);
  //   } else {
  //     return workingStaffs;
  //   }
  // });

  const formatHour = (hour, userNativeLang, showHourSuffix = true) => {
    const hoursStr = userNativeLang === languageSelectOptions.fr.value ? 'heures' : 'hours';
    const hourStr = userNativeLang === languageSelectOptions.fr.value ? 'heure' : 'hour';
    const minutesStr = userNativeLang === languageSelectOptions.fr.value ? 'minutes' : 'minutes';
    const minuteStr = userNativeLang === languageSelectOptions.fr.value ? 'minute' : 'minute';
    const hourInt = parseInt(hour);
    const min = Math.round((hour - hourInt) * 60);
    const hourSuffix = hour > 1 ? hoursStr : hourStr;
    const minuteSuffix = min > 1 ? minutesStr : minuteStr;
    // if (!showHourSuffix) {
    //   return `${hourInt > 9 ? '' : '0'}${hourInt}:${min > 9 ? '' : '0'}${min}`;
    // }
    // return min > 0
    //   ? hourInt > 0
    //     ? `${hourInt} ${hourSuffix} ${min} ${minuteSuffix}`
    //     : `${min} ${minuteSuffix}`
    //   : hourInt > 0
    //   ? `${hourInt} ${hourSuffix}`
    //   : `${min} ${minuteSuffix}`;

    if (!showHourSuffix) {
      return `${hourInt > 9 ? '' : '0'}${hourInt}:${min > 9 ? '' : '0'}${min}`;
    }
    const hours = String(Math.floor(hourInt)).padStart(2, '0');
    const minutes = String(min).padStart(2, '0');

    return `${hours}h${minutes}`;
    // : hourInt > 0
    // ? `${hours}h`
    // : `${minutes}`;
  };

  const formatDate = date =>
    userNativeLang === languageSelectOptions.fr.value
      ? moment(date).format('DD/MM/YYYY')
      : moment(date).format('DD/MM/YYYY');

  const generateInvoice = ({ e, id, name }) => {
    setDownloading(true);
    e.preventDefault();
    // console.log(123, status);
    //working but not npm supported

    // const element = document.getElementById(id);
    // console.log(222, element, id);
    // const options = {
    //   filename: 'Listing-invoice.pdf', // Set the desired file name here
    //   margin: 10,
    //   jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
    // };
    // html2pdf(element, options);

    //-----------------------------------------------------------
    const element = document.getElementById(id);
    html2canvas(element, { scale: 8 }).then(canvas => {
      const imgData = canvas.toDataURL('image/jpeg', 1.0);
      const doc = new jsPDF('p', 'mm', 'a4');
      const compWidth = doc.internal.pageSize.getWidth() - 20;
      const compHeight = doc.internal.pageSize.getHeight();
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;

      // Define the desired upper and lower gap size
      // const upperGap = 10; // Adjust as needed
      // const lowerGap = 10; // Adjust as needed
      //   const availableHeight = compHeight - upperGap - lowerGap;
      //   const ratio = availableHeight / imgHeight;
      //   const newImgHeight = imgHeight * ratio;

      //   // Calculate the vertical position to reduce the upper gap
      //   const imgY = upperGap;

      //   const imgX = (compWidth - imgWidth * ratio) / 2;
      const ratio = Math.min(compWidth / imgWidth, compHeight / imgHeight);
      const imgX = (compWidth - imgWidth * ratio) / 2 + 10;
      const imgY = 20;
      // const imgY = (compHeight - imgHeight * ratio) / 2;

      doc.addImage(imgData, 'JPEG', imgX, imgY, imgWidth * ratio, imgHeight * ratio);
      // doc.addImage(imgData, 'JPEG', imgX, imgY, imgWidth * ratio, newImgHeight);
      doc.setProperties({
        image_compression: 'NONE',
      });
      {
        doc.save(`${name}.pdf`);
      }
      setDownloading(false);
    });
  };

  return (
    <FinalForm
      onSubmit={() => { }}
      render={fieldProps => {
        const { values, form } = fieldProps;
        const { showInvoiceModal, invoiceIndx = -1 } = values;
        const invoiceDetails = invoiceIndx >= 0 ? workerJobs[invoiceIndx] : null;

        const isCancelledByBusiness =
          invoiceDetails?.listing?.attributes?.metadata?.isCancelledByBusiness;
        const cancelDate = isCancelledByBusiness
          ? invoiceDetails?.listing?.attributes?.metadata?.closeDate
          : null;
        const sep = userNativeLang === languageSelectOptions.fr.value ? 'à' : 'at';
        const cancelDateStr = cancelDate
          ? `${moment(cancelDate).format('DD MMM YYYY')} ${sep} ${moment(cancelDate).format(
              'HH[h]mm'
            )}`
          : '';

        const selectInvoiceForJob = (e, indx) => {
          e.preventDefault();
          form.batch(() => {
            form.change('showInvoiceModal', true);
            form.change('invoiceIndx', indx);
          });
        };

        const closeInvoiceModal = e => {
          e.preventDefault();
          form.batch(() => {
            form.change('showInvoiceModal', false);
            form.change('invoiceIndx', -1);
          });
        };

        return (
          <Form
            // className={classes}
            onSubmit={e => {
              //   setSubmittedValues(values);
              //   handleSubmit(e);
            }}
          >
            <div className={css.WorkerForm}>
              <div className={css.tabDiv}>
                <button
                  type="button"
                  className={classNames(css.desktopReviewsTabNav, {
                    [css.selectedTab]: tab === workerDashboardTab.currentShifts,
                  })}
                  onClick={() => {
                    history.replace(
                      createResourceLocatorString(
                        'WorkerDashboardPage',
                        routeConfiguration(),
                        { id: params.id },
                        { tab: workerDashboardTab.currentShifts }
                      )
                    );
                    // workerData();
                  }}
                >
                  <FormattedMessage id="WorkerDashboardForm.currentShiftsLabel" />
                </button>
                <span className={css.vDivider}></span>

                <button
                  type="button"
                  className={classNames(css.desktopReviewsTabNav, {
                    [css.selectedTab]: tab === workerDashboardTab.upcomingShifts,
                  })}
                  onClick={() => {
                    history.replace(
                      createResourceLocatorString(
                        'WorkerDashboardPage',
                        routeConfiguration(),
                        { id: params.id },
                        { tab: workerDashboardTab.upcomingShifts }
                      )
                    );
                    // workerData();
                  }}
                >
                  <FormattedMessage id="WorkerDashboardForm.upcomingShiftsLabel" />
                </button>
                <span className={css.vDivider}></span>
                <button
                  type="button"
                  className={classNames(css.desktopReviewsTabNav, {
                    [css.selectedTab]: tab === workerDashboardTab.pastShifts,
                  })}
                  onClick={() => {
                    history.replace(
                      createResourceLocatorString(
                        'WorkerDashboardPage',

                        routeConfiguration(),
                        { id: params.id },
                        { tab: workerDashboardTab.pastShifts }
                      )
                    );
                    // workerData();
                  }}
                >
                  <FormattedMessage id="WorkerDashboardForm.pastShiftsLabel" />
                </button>
                <span className={css.vDivider}></span>

                <button
                  type="button"
                  className={classNames(css.desktopReviewsTabNav, {
                    [css.selectedTab]: tab === workerDashboardTab.earning,
                  })}
                  onClick={() => {
                    history.replace(
                      createResourceLocatorString(
                        'WorkerDashboardPage',
                        routeConfiguration(),
                        { id: params.id },
                        { tab: workerDashboardTab.earning, box: earningFetchType.lastWeek }
                      )
                    );
                  }}
                >
                  <FormattedMessage id="WorkerDashboardForm.earningLabel" />
                </button>
                <span className={css.slider}></span>
              </div>

              {fetchInProgress ? (
                <>
                  <IconSpinner />
                </>
              ) : tab === workerDashboardTab.currentShifts ? (
                <>
                  {workingStaffs?.length === 0 ? (
                    <>
                      <div className={css.tabContentContainer}>
                        <Clock />
                        <FormattedMessage id="WorkerDashboardForm.noCurrentShift" />
                      </div>
                    </>
                  ) : (
                    <div className={css.ShiftListingWrap}>
                      {workingStaffs &&
                        workingStaffs.length > 0 &&
                        workingStaffs.map(m => (
                          <JobListingAppliedCard
                            userNativeLang={userNativeLang}
                            history={history}
                            fromWorkerDashboardForm={true}
                            tab={tab}
                            // listingTransaction={listingTransactions[key]}
                            listingDetails={m.listing}
                            // listingId={key}
                            intl={intl}
                          // key={key}
                          />
                        ))}
                      {/* {paginationLinks} */}
                    </div>
                  )}
                </>
              ) : tab === workerDashboardTab.upcomingShifts ? (
                <>
                  {workingStaffs?.length === 0 ? (
                    <>
                      <div className={css.tabContentContainer}>
                        <Clock />
                        <FormattedMessage id="WorkerDashboardForm.noUpcomingShift" />
                      </div>
                    </>
                  ) : (
                    <div className={css.ShiftListingWrap}>
                      {' '}
                      {workingStaffs &&
                        workingStaffs.length > 0 &&
                        workingStaffs.map(m => (
                          <JobListingAppliedCard
                            userNativeLang={userNativeLang}
                            history={history}
                            fromWorkerDashboardForm={true}
                            // listingTransaction={listingTransactions[key]}
                            listingDetails={m.listing}
                            // listingId={key}
                            intl={intl}
                            tab={tab}
                          // key={key}
                          />
                        ))}
                      {/* {paginationLinks} */}
                    </div>
                  )}
                </>
              ) : tab === workerDashboardTab.pastShifts ? (
                <>
                  {workingStaffs?.length === 0 ? (
                    <>
                      <div className={css.tabContentContainer}>
                        <Clock />
                        <FormattedMessage id="WorkerDashboardForm.noPastShift" />
                      </div>
                    </>
                  ) : (
                    <div className={css.ShiftListingWrap}>
                      {' '}
                      {workingStaffs &&
                        workingStaffs.length > 0 &&
                        workingStaffs.map(m => (
                          <JobListingAppliedCard
                            userNativeLang={userNativeLang}
                            history={history}
                            fromWorkerDashboardForm={true}
                            // listingTransaction={listingTransactions[key]}
                            listingDetails={m.listing}
                            // listingId={key}
                            intl={intl}
                            tab={tab}
                          // key={key}
                          />
                        ))}
                      {/* {paginationLinks} */}
                    </div>
                  )}
                </>
              ) : tab === workerDashboardTab.earning ? (
                <div className={css.earningContentContainer}>
                  <div className={classNames(css.earningRow, {})}>
                    <div
                      className={classNames(css.earningCard, {
                        [css.selectedEarningTab]: earningTabSelected === earningFetchType.lastWeek,
                      })}
                      onClick={
                        () =>
                          history.replace(
                            createResourceLocatorString(
                              'WorkerDashboardPage',
                              routeConfiguration(),
                              { id: params.id },
                              { tab: workerDashboardTab.earning, box: earningFetchType.lastWeek }
                            )
                          )
                        // setEarningTabSelected(earningFetchType.lastWeek),
                        // onfetchEarning({ box: earningFetchType.lastWeek })
                      }
                    >
                      <label>
                        {/* <FormattedMessage id="ActivityFeed.today" /> */}
                        <FormattedMessage id="ActivityFeed.lastWeek" />
                      </label>
                      <span>
                        {formatMoney(
                          intl,
                          new Money(workerEarnings[earningFetchType.lastWeek] || 0, config.currency)
                        )}
                      </span>
                    </div>
                    <div
                      className={classNames(css.earningCard, {
                        [css.selectedEarningTab]: earningTabSelected === earningFetchType.lastMonth,
                      })}
                      onClick={
                        () =>
                          history.replace(
                            createResourceLocatorString(
                              'WorkerDashboardPage',
                              routeConfiguration(),
                              { id: params.id },
                              { tab: workerDashboardTab.earning, box: earningFetchType.lastMonth }
                            )
                          )
                        // setEarningTabSelected(earningFetchType.lastMonth),
                        // onfetchEarning({ box: earningFetchType.lastMonth })
                      }
                    >
                      <label>
                        {/* <FormattedMessage id="ActivityFeed.week" /> */}
                        <FormattedMessage id="ActivityFeed.LastMonth" />
                      </label>
                      <span>
                        {formatMoney(
                          intl,
                          new Money(
                            workerEarnings[earningFetchType.lastMonth] || 0,
                            config.currency
                          )
                        )}
                      </span>
                    </div>
                    <div
                      className={classNames(css.earningCard, {
                        [css.selectedEarningTab]:
                          earningTabSelected === earningFetchType.yearToDate,
                      })}
                      onClick={
                        () =>
                          history.replace(
                            createResourceLocatorString(
                              'WorkerDashboardPage',
                              routeConfiguration(),
                              { id: params.id },
                              { tab: workerDashboardTab.earning, box: earningFetchType.yearToDate }
                            )
                          )
                        // setEarningTabSelected(earningFetchType.yearToDate),
                        // onfetchEarning({ box: earningFetchType.yearToDate })
                      }
                    >
                      <label>
                        {/* <FormattedMessage id="ActivityFeed.month" /> */}
                        <FormattedMessage id="ActivityFeed.YearToDate" />
                      </label>
                      <span>
                        {formatMoney(
                          intl,
                          new Money(
                            workerEarnings[earningFetchType.yearToDate] || 0,
                            config.currency
                          )
                        )}
                      </span>
                    </div>
                    <div
                      className={classNames(css.earningCard, {
                        [css.selectedEarningTab]:
                          earningTabSelected === earningFetchType.totalEarning,
                      })}
                      onClick={
                        () =>
                          history.replace(
                            createResourceLocatorString(
                              'WorkerDashboardPage',
                              routeConfiguration(),
                              { id: params.id },
                              {
                                tab: workerDashboardTab.earning,
                                box: earningFetchType.totalEarning,
                              }
                            )
                          )
                        // setEarningTabSelected(earningFetchType.totalEarning),
                        // onfetchEarning({ box: earningFetchType.totalEarning })
                      }
                    >
                      <label>
                        {/* <FormattedMessage id="ActivityFeed.year" /> */}
                        <FormattedMessage id="ActivityFeed.TotalEarning" />
                      </label>
                      <span>
                        {formatMoney(
                          intl,
                          new Money(
                            workerEarnings[earningFetchType.totalEarning] || 0,
                            config.currency
                          )
                        )}
                      </span>
                    </div>
                  </div>
                  <div className={css.bottomDataContent}>
                    <div className={css.topRow}>
                      <span>
                        {earningTabSelected === earningFetchType.lastWeek ? (
                          <span>{<FormattedMessage id="ActivityFeed.lastWeek" />}</span>
                        ) : earningTabSelected === earningFetchType.lastMonth ? (
                          <span>{<FormattedMessage id="ActivityFeed.LastMonth" />}</span>
                        ) : earningTabSelected === earningFetchType.yearToDate ? (
                          <span>{<FormattedMessage id="ActivityFeed.YearToDate" />}</span>
                        ) : earningTabSelected === earningFetchType.totalEarning ? (
                          <span>{<FormattedMessage id="ActivityFeed.TotalEarning" />}</span>
                        ) : null}
                      </span>
                      {/* <div className={css.datesDiv}>
                        <FieldDateInput
                          name="fromDate"
                          id={'fromDate'}
                          placeholderText={fromToDatePlaceholder}
                          label={fromDateLabel}
                          //   validate={birthdateValidator}
                          className={classNames(textfield, css.dateInputDiv)}
                          errorClassName={errorTextField}
                          //   isOutsideRange={date => moment().diff(date, 'days') <= 0}
                          displayFormat="DD/MM/YYYY"
                        />
                        <FieldDateInput
                          name="toDate"
                          id={'toDate'}
                          placeholderText={fromToDatePlaceholder}
                          label={toDateLabel}
                          //   validate={birthdateValidator}
                          className={classNames(textfield, css.dateInputDiv)}
                          errorClassName={errorTextField}
                          //   isOutsideRange={date => moment().diff(date, 'days') <= 0}
                          displayFormat="DD/MM/YYYY"
                          userNativeLang={userNativeLang}
                        />
                      </div> */}
                    </div>
                    <div className={css.bottomDiv}>
                      <div className={css.TableContainer}>
                        <table
                          className={classNames(css.timeStatementTable, css.workerInvoiceTable)}
                        >
                          <tbody>
                            <tr>
                              <th className={css['table-header']}>
                                <FormattedMessage id="WorkerDashboardForm.gigId" />
                              </th>
                              <th className={css['table-header']}>
                                <FormattedMessage id="WorkerDashboardForm.GigName" />
                              </th>
                              <th className={css['table-header']}>
                                <FormattedMessage id="WorkerDashboardForm.Date" />
                              </th>
                              <th className={css['table-header']}>
                                <FormattedMessage id="ListingPage.locationTitle" />
                              </th>
                              <th className={css['table-header']}>
                                {' '}
                                <FormattedMessage id="FieldDateTimeInput.startTime" />
                              </th>
                              <th className={css['table-header']}>
                                {' '}
                                <FormattedMessage id="FieldDateTimeInput.endTime" />
                              </th>
                              <th className={css['table-header']}>
                                <FormattedMessage id="WorkerDashboardForm.TotalBreakTime" />
                              </th>
                              <th className={css['table-header']}>
                                <FormattedMessage id="WorkerDashboardForm.TotalWorkingHours" />
                              </th>
                              <th className={css['table-header']}>
                                <FormattedMessage id="WorkerDashboardForm.HourlyWages" />
                              </th>
                              <th className={css['table-header']}>
                                <FormattedMessage id="WorkerDashboardForm.TotalEarnings" />
                              </th>
                              <th>&nbsp;</th>
                            </tr>

                            {workerJobs.map((job, indx) => {
                              const { listing, timestatement } = job;
                              const ensuredListing = ensureListing(listing);
                              const {
                                id: { uuid },
                              } = ensuredListing;
                              const {
                                title,
                                price,
                                publicData: {
                                  djobStartTime,
                                  djobEndTime,
                                  djobStartDate,
                                  listingAddress,
                                  gigId,
                                } = {},
                                deleted,
                              } = ensuredListing?.attributes;

                              const {
                                finalWorkingHour,
                                finalPayment,
                                totalBreakTime,
                              } = timestatement;

                              const jobDate = formatDate(djobStartDate);
                              const addressValue =
                                listingAddress?.[userNativeLang] || listingAddress?.address || '';
                              const fullAddress = `${addressValue}, ${listingAddress?.postalCode}`;
                              const params = { id: uuid, slug: createSlug(title || 'listing') };
                              return (
                                true && (
                                  <tr key={indx} className={css['table-row']}>
                                    <td>
                                      <NamedLink
                                        className={css.linkClickable}
                                        name="ListingPage"
                                        params={params}
                                      >
                                        {(gigId || '').toUpperCase()}
                                      </NamedLink>
                                    </td>
                                    <td>
                                      <NamedLink
                                        className={css.linkClickable}
                                        name="ListingPage"
                                        params={params}
                                      >
                                        {title.toUpperCase()}
                                      </NamedLink>
                                    </td>
                                    {/* <td>{title}</td> */}
                                    <td>{jobDate}</td>
                                    <td>{fullAddress}</td>
                                    <td>{djobStartTime}</td>
                                    <td>{djobEndTime}</td>
                                    <td>{formatHour(totalBreakTime, userNativeLang, true)}</td>
                                    <td>{formatHour(finalWorkingHour, userNativeLang, true)}</td>
                                    <td>
                                      {formatMoney(
                                        intl,
                                        new Money(
                                          price?.amount || 0,
                                          price?.currency || config.currency
                                        )
                                      )}
                                    </td>
                                    <td>
                                      {formatMoney(
                                        intl,
                                        new Money(
                                          finalPayment * unitDivisor(config.currency),
                                          config.currency
                                        )
                                      )}
                                    </td>
                                    <td>
                                      <InlineTextButton
                                        type="button"
                                        onClick={e => selectInvoiceForJob(e, indx)}
                                      >
                                        <FormattedMessage id="BusinessDashboardInvoicePage.viewInvoice" />
                                      </InlineTextButton>
                                    </td>
                                  </tr>
                                )
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                      <div className={css.totalearningDiv}>
                        <span>
                          <FormattedMessage id="WorkerDashboardForm.TotalEarnings" />:
                        </span>
                        <span>
                          {formatMoney(
                            intl,
                            new Money(workerEarnings[earningTabSelected] || 0, config.currency)
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
            <Modal
              id="workerInvoice"
              onManageDisableScrolling={onManageDisableScrolling}
              isOpen={showInvoiceModal}
              onClose={closeInvoiceModal}
              usePortal
            >
              {invoiceDetails ? (
                <>
                  <div>
                    <div className={css.invoiceContainer}>
                      <div className={css.invoiceTop}>
                        <div className={css.invoiceTopLeft}>
                          <div className={css.invoiceInfo}>
                            {' '}
                            <FormattedMessage id="Invoice.BillToPay" className={css.Text} />
                          </div>
                        </div>
                        <div className={css.invoiceMiddle}>
                          <div className={classNames(css.businessName, css.invoiceInfo)}>
                            {' '}
                            <span>
                              {' '}
                              {invoiceDetails.provider.attributes.profile.publicData.companyName}
                            </span>
                          </div>
                          <div className={css.Text}>
                            {invoiceDetails.listing.attributes?.publicData?.listingAddress?.[
                              userNativeLang
                            ] ||
                              invoiceDetails.listing.attributes?.publicData?.listingAddress
                                ?.address}
                            {', '}
                            {
                              invoiceDetails.listing.attributes?.publicData?.listingAddress
                                ?.postalCode
                            }
                          </div>
                          <div className={css.Text}>
                            {currentUser.attributes.profile.publicData.customId}
                          </div>
                        </div>
                        <div className={css.invoiceTopRight}>
                          <div className={css.invoiceInfo}>
                            {' '}
                            <FormattedMessage id="Invoice.Invoice" className={css.Text} />{' '}
                          </div>
                          <div className={css.DataDiv}>
                            <FormattedMessage id="Invoice.invoiceDate" className={css.Text} />
                            <span>
                              {moment(invoiceDetails?.timestatement?.updatedAt).format('DD/MM/YY')}
                            </span>
                          </div>
                          <div className={css.DataDiv}>
                            <FormattedMessage id="Invoice.paymentTerms" className={css.Text} />
                            <span>
                              <FormattedMessage id="Invoice.paymentType" />
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className={css.padding}>
                        <div className={css.invoiceWrapper}>
                          <div className={css.invoice}>
                            {' '}
                            <span>{intl.formatMessage({ id: 'Invoice.djobInfo' })}&nbsp;:</span>
                          </div>

                          <div className={css.extraDiv}>
                            <div className={css.TextDiv}>
                              <span>{intl.formatMessage({ id: 'Invoice.gigTitle' })}</span>
                              <span>{invoiceDetails.listing.attributes.title}</span>
                            </div>

                            {/* address section */}
                            {invoiceDetails.listing.attributes?.publicData?.listingAddress
                              ?.address ||
                              invoiceDetails.listing.attributes?.publicData?.listingAddress
                                ?.postalCode ? (
                              <div className={css.locationDiv}>
                                <span>{intl.formatMessage({ id: 'Invoice.gigAddress' })}</span>
                                <span>
                                  {
                                    invoiceDetails.listing.attributes.publicData.listingAddress
                                      ?.address
                                  }
                                  ,
                                  {
                                    invoiceDetails.listing.attributes.publicData.listingAddress
                                      ?.postalCod
                                  }
                                </span>
                              </div>
                            ) : null}
                          </div>

                          <div className={css.extraDiv}>
                            <div className={css.TotalWorkerDiv}>
                              <FormattedMessage id="SearchPage.category" className={css.Text} />{' '}
                              <span className={invoiceCss.Text}>
                                {jobCategoryOptions
                                  ?.filter(f =>
                                    invoiceDetails.listing.attributes.publicData?.jobCategories.find(
                                      m => m.category === f.value
                                    )
                                  )
                                  ?.map(m => m.label[userNativeLang])}
                              </span>
                              <span className={invoiceCss.Text}>
                                {` - `}
                                {
                                  jobSubCategoryOptions.find(
                                    m =>
                                      invoiceDetails.listing.attributes.publicData?.jobCategories[0]
                                        ?.subCategory === m.value
                                  )?.label[userNativeLang]
                                }
                              </span>
                            </div>

                            {/* price */}

                            <div className={css.hourDiv}>
                              <FormattedMessage
                                id="SearchPage.Priceperhour"
                                className={invoiceCss.Text}
                              />
                              <span className={invoiceCss.No}>
                                {formatMoney(
                                  intl,
                                  new Money(
                                    invoiceDetails.listing.attributes?.price?.amount || 0,
                                    invoiceDetails.listing.attributes?.price?.currency ||
                                    config.currency
                                  )
                                )}
                              </span>
                            </div>
                            {/* hours */}
                            <div className={css.hourDiv}>
                              <FormattedMessage id="Invoice.djobDate" />
                              <span className={invoiceCss.No}>
                                {invoiceDetails.timestatement.attendance.length > 1 ? (
                                  <React.Fragment>
                                    {' '}
                                    {formatDate(
                                      invoiceDetails.listing.attributes.publicData.djobStartDate
                                    )}{' '}
                                    -{' '}
                                    {formatDate(
                                      invoiceDetails.listing.attributes.publicData.djobEndDate
                                    )}
                                  </React.Fragment>
                                ) : (
                                  <React.Fragment>
                                    {' '}
                                    {formatDate(
                                      invoiceDetails.listing.attributes?.publicData?.djobStartDate
                                    )}
                                  </React.Fragment>
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                        {isCancelledByBusiness ? (
                          <p className={css.gigCancelError}>
                            <FormattedMessage
                              id="Invoice.listingClose"
                              values={{ date: cancelDateStr }}
                            />
                          </p>
                        ) : null}
                        <div className={css.PriceBreakDownContainer}>
                          <p className={css.invoiceHeading}>
                            <FormattedMessage id="Invoice.employeFeeInfo" />
                          </p>

                          <div className={css.workerDetails}>
                            <div className={css.top}>
                              <div className={css.left}>
                                <div>
                                  <FormattedMessage id="Invoice.billBy" />
                                </div>
                                <div className={css.workerDetailsData}>
                                  <p>
                                    <FormattedMessage id="Invoice.djobberName" />
                                    <span>{currentUser?.attributes?.profile.displayName}</span>
                                  </p>
                                  <p>
                                    <FormattedMessage id="Invoice.djobberId" />
                                    <span>
                                      {currentUser.attributes.profile.publicData.customId}
                                    </span>
                                  </p>
                                </div>
                              </div>
                              <div className={css.right}>
                                <div>
                                  <FormattedMessage id="Invoice.djobInfo" />
                                </div>
                                <div className={css.workerDetailsData}>
                                  <p>
                                    <FormattedMessage id="Invoice.djobWorkingHour" />
                                    <span>
                                      {formatHour(
                                        moment(invoiceDetails.timestatement.endDate).diff(
                                          invoiceDetails.timestatement.startDate,
                                          'minute'
                                        ) / 60,
                                        userNativeLang,
                                        true
                                      )}
                                    </span>
                                  </p>
                                  <p>
                                    <FormattedMessage id="Invoice.startTime" />{' '}
                                    <span>
                                      {invoiceDetails.listing.attributes?.publicData?.djobStartTime}
                                    </span>{' '}
                                    &nbsp;&nbsp;
                                    <FormattedMessage id="Invoice.endTime" />{' '}
                                    <span>
                                      {invoiceDetails.listing.attributes?.publicData?.djobEndTime}
                                    </span>
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className={css.bottom}>
                              <div className={classNames(css.row, css.tableHeadingRow)}>
                                <span>
                                  {intl.formatMessage({ id: 'Invoice.workerInvoiceNumber' })}
                                </span>
                                <span>{intl.formatMessage({ id: 'Invoice.date' })}</span>
                                <span>
                                  {intl.formatMessage({ id: 'Invoice.totalWorkingHour' })}
                                </span>
                                <span>{intl.formatMessage({ id: 'Invoice.PriceHour' })}</span>
                                <span>{intl.formatMessage({ id: 'Invoice.Charged' })}</span>
                              </div>

                              {invoiceDetails.timestatement.attendance.map((data, indx) => {
                                return (
                                  <div className={classNames(css.row, css.tableDataRow)}>
                                    {/* <div className={invoiceCss.DataDiv} key={indx}> */}
                                    <span className={css.invoiceNum}>
                                      {invoiceDetails.listing?.attributes?.publicData?.gigId}/
                                      {currentUser.attributes.profile.publicData.customId}
                                    </span>
                                    <span>
                                      {invoiceDetails?.timestatement?.startDate
                                        ? moment(invoiceDetails.timestatement.startDate).format(
                                          'YYYY-MM-DD'
                                        )
                                        : '-'}
                                    </span>
                                    <span>{data.totalWorkingHour}</span>
                                    <span>
                                      {formatMoney(
                                        intl,
                                        new Money(
                                          invoiceDetails.listing.attributes?.price?.amount || 0,
                                          invoiceDetails.listing.attributes?.price?.currency ||
                                          config.currency
                                        )
                                      )}
                                    </span>
                                    <span>
                                      {formatMoney(
                                        intl,
                                        new Money(
                                          (invoiceDetails.listing.attributes?.price?.amount || 0) *
                                          data.totalWorkingHour,
                                          invoiceDetails.listing.attributes?.price?.currency ||
                                          config.currency
                                        )
                                      )}
                                    </span>
                                    {/* </div> */}
                                  </div>
                                );
                              })}
                              {/* {attendance.map((att, indx) => {
                              const { paymentDate, totalWorkingHour, totalPaymentForShow } = att;
                              const paymentDatestr = moment(paymentDate)
                                .subtract(userOffset)
                                .format('YYYY-MM-DD');

                              const totalPaymentMoney = new Money(
                                totalPaymentForShow * unitDivisor(config.currency),
                                config.currency
                              );
                              return (
                                <div key={indx} className={classNames(css.row, css.tableDataRow)}>
                                  <span className={css.invoiceNum}>
                                    {currentListing?.attributes?.publicData?.gigId}/{currentUser.attributes.profile.publicData.customId}
                                  </span>
                                  <span>{paymentDatestr}</span>
                                  <span>{totalWorkingHour}</span>
                                  <span>{hourlyRate}</span>
                                  <span>{formatMoney(intl, totalPaymentMoney)}</span>
                                </div>
                              );
                            })} */}
                              {/* <div className={classNames(css.row, css.tableDataRow)}>
                              <span />
                              <span />
                              <span>
                                {intl.formatMessage({ id: 'BusinessCheckoutPage.gstTaxes' })}
                              </span>
                              <span />
                              <span>-</span>
                            </div> */}
                              {/* <div className={classNames(css.row, css.tableDataRow)}>
                              <span />
                              <span />
                              <span>
                                {intl.formatMessage({ id: 'BusinessCheckoutPage.qstTaxes' })}
                              </span>
                              <span />
                              <span>-</span>
                            </div> */}

                              {/* total amount */}
                              {/* <div className={classNames(css.row, css.tableDataRow)}>
                              <span />
                              <span />
                              <span>{intl.formatMessage({ id: 'Invoice.TotalAmount' })}</span>
                              <span />
                              <span>{formatMoney(intl, finalPaymentMoney)}</span>
                            </div> */}
                            </div>
                          </div>
                          {/* <div>
                          <p className={css.invoiceHeading}>
                            <FormattedMessage id="Invoice.platformFeeInfo" />
                          </p>
                          <div className={css.djobInfoContent}>
                            <Logo
                              format="desktop"
                              className={css.logo}
                              alt={intl.formatMessage({
                                id: 'TopbarDesktop.logo',
                              })}
                            />
                            <div className={css.djobInfo}>
                              <span className={css.email}>
                                <FormattedMessage id="Invoice.platformEmailInfo" />
                                <span>{djobMail}</span>
                              </span>
                              <span className={css.site}>
                                <FormattedMessage id="Invoice.platformSiteInfo" />
                                <span>{djobSite}</span>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div className={css.finalBreakDown}>
                            <div className={css.tableHeadingRow}>
                              <span>{intl.formatMessage({ id: 'Invoice.invoiceNumber' })}</span>
                              <span>
                                {intl.formatMessage({ id: 'Invoice.totalWorkerFeeInfo' })}
                              </span>
                              <span>{intl.formatMessage({ id: 'Invoice.djobFeeInfo' })}</span>
                              <span>{intl.formatMessage({ id: 'Invoice.totalCharged' })}</span>
                            </div>
                            <div className={css.tableDataRow}>
                              <span> {currentListing?.attributes?.publicData?.gigId}</span>
                              <span>{totalAmountAsMoney}</span>
                              <span>{djobComissionPercentage}%</span>
                              <span>{djobComissionAsMoney}</span>
                            </div>
                            <div className={css.tableDataRow}>
                              <span> </span>
                              <span>
                                {intl.formatMessage({ id: 'BusinessCheckoutPage.gstTaxes' })}
                              </span>
                              <span>{gstNumber}</span>
                              <span>{gstTaxAsMoney}</span>
                            </div>
                            <div className={css.tableDataRow}>
                              <span> </span>
                              <span>
                                {intl.formatMessage({ id: 'BusinessCheckoutPage.qstTaxes' })}
                              </span>
                              <span>{qstNumber}</span>
                              <span>{qstTaxAsMoney}</span>
                            </div>
                            <div className={css.tableDataRow}>
                              <span> </span>
                              <span>{intl.formatMessage({ id: 'Invoice.TotalAmount' })}</span>
                              <span></span>
                              <span>{totalcommissionAsMoney}</span>
                            </div>
                          </div>
                        </div> */}
                        </div>
                      </div>
                    </div>
                    <div className={css.btnDiv}>
                      <Button
                        onClick={e => {
                          generateInvoice({
                            e,
                            id: invoiceDetails.timestatement._id,
                            name: `Djob ${invoiceDetails.listing.attributes.title}`,
                          });
                        }}
                        className={css.submitButton}
                        inProgress={downloading}
                      >
                        <FormattedMessage id="ListingPublishedPage.invoiceBtn" />
                      </Button>
                    </div>
                  </div>

                  {/* --------------------------------------------new invoice ---------------------------------------- */}
                </>
              ) : null}
            </Modal>
          </Form>
        );
      }}
    />
  );
}

export default WorkerDashboardForm;

// old time statement invoice code here kept for reference
// <div className={css.invoiceContainer} id={invoiceDetails.timestatement._id}>
//                       <div className={invoiceCss.InvoHeading}>
//                         <div className={invoiceCss.rightDiv}>
//                           <div className={invoiceCss.SosAndTax}>
//                             <div className={invoiceCss.taxTextBContent}>
//                               <div className={invoiceCss.taxTextB}>
//                                 <FormattedMessage id="Invoice.TaxInvoice" />
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                       <div className={invoiceCss.padding}>
//                         <div className={invoiceCss.InfoContainer}>
//                           {/* <div className={invoiceCss.invoiceInfoWrapper}>
//                             <div className={invoiceCss.invoiceInfo}>
//                               {' '}
//                               <FormattedMessage
//                                 id="Invoice.invoiceInfoText"
//                                 className={invoiceCss.Text}
//                               />{' '}
//                             </div>
//                             <div className={invoiceCss.informationContainer}>
//                               <div className={invoiceCss.DataDiv}>
//                                 <div>
//                                   {' '}
//                                   <FormattedMessage
//                                     id="Invoice.invoiceNumber"
//                                     className={invoiceCss.Text}
//                                   />
//                                 </div>
//                                 <div className={invoiceCss.No}>
//                                   {' '}
//                                   {invoiceDetails.listing.attributes.publicData.gigId}
//                                 </div>
//                               </div>

//                               <div className={invoiceCss.DataDiv}>
//                                 <div>
//                                   {' '}
//                                   <FormattedMessage
//                                     id="Invoice.paymentTerms"
//                                     className={invoiceCss.Text}
//                                   />
//                                 </div>
//                                 <div className={invoiceCss.No}>
//                                   <FormattedMessage id="Invoice.paymentTypeAccount" />
//                                 </div>
//                               </div>
//                               <div className={invoiceCss.DataDiv}>
//                                 <div>
//                                   {' '}
//                                   <FormattedMessage
//                                     id="Invoice.customerNo"
//                                     className={invoiceCss.Text}
//                                   />
//                                 </div>
//                                 <div className={invoiceCss.No}>
//                                   {' '}
//                                   {currentUser.attributes.profile.publicData.customId}
//                                 </div>
//                               </div>
//                               <div className={invoiceCss.DataDiv}>
//                                 <div>
//                                   {' '}
//                                   <FormattedMessage
//                                     id="Invoice.currency"
//                                     className={invoiceCss.Text}
//                                   />
//                                 </div>
//                                 <div className={invoiceCss.No}>CAD</div>
//                               </div>
//                             </div>
//                           </div> */}
//                           {/* <div className={invoiceCss.billToWrapper}>
//                             <div className={invoiceCss.invoiceInfo}>
//                               {' '}
//                               <FormattedMessage
//                                 id="Invoice.BillToPay"
//                                 className={invoiceCss.Text}
//                               />
//                             </div>
//                             <div className={invoiceCss.businessName}>
//                               {invoiceDetails.provider.attributes.profile.publicData.companyName}
//                             </div>
//                             <div className={invoiceCss.Text}>
//                               {invoiceDetails.listing.attributes.publicData.listingAddress?.[
//                                 userNativeLang
//                               ] ||
//                                 invoiceDetails.listing.attributes.publicData.listingAddress
//                                   ?.address}
//                               {', '}
//                               {
//                                 invoiceDetails.listing.attributes.publicData.listingAddress
//                                   ?.postalCode
//                               }
//                             </div>
//                           </div> */}
//                         </div>
//                         <div className={invoiceCss.wrapper}>
//                           <div className={invoiceCss.invoice}>
//                             {' '}
//                             <FormattedMessage id="Invoice.InvoiceGig" />
//                           </div>

//                           <div className={invoiceCss.Text}>
//                             {' '}
//                             {invoiceDetails.listing.attributes.title}
//                           </div>

//                           {/* //category */}
//                           <div className={invoiceCss.categoryWrapper}>
//                             <span className={invoiceCss.Text}>
//                               {jobCategoryOptions
//                                 ?.filter(f =>
//                                   invoiceDetails.listing.attributes.publicData?.jobCategories.find(
//                                     m => m.category === f.value
//                                   )
//                                 )
//                                 ?.map(m => m.label[userNativeLang])}
//                             </span>

//                             <span className={invoiceCss.Text}>
//                               {` - `}
//                               {
//                                 jobSubCategoryOptions.find(
//                                   m =>
//                                     invoiceDetails.listing.attributes.publicData?.jobCategories[0]
//                                       ?.subCategory === m.value
//                                 )?.label[userNativeLang]
//                               }
//                             </span>
//                           </div>

//                           {invoiceDetails.listing.attributes.publicData.listingAddress?.address ||
//                           invoiceDetails.listing.attributes.publicData.listingAddress
//                             ?.postalCode ? (
//                             <div className={invoiceCss.locationDiv}>
//                               <div className={invoiceCss.locateIcon}>
//                                 <Location className={invoiceCss.location} />{' '}
//                               </div>
//                               <span>
//                                 {' '}
//                                 {
//                                   invoiceDetails.listing.attributes.publicData.listingAddress
//                                     ?.address
//                                 }
//                                 ,{' '}
//                                 {
//                                   invoiceDetails.listing.attributes.publicData.listingAddress
//                                     .postalCode
//                                 }
//                               </span>
//                             </div>
//                           ) : null}

//                           {/* price */}

//                           <span className={invoiceCss.gigPrice}>
//                             <FormattedMessage
//                               id="SearchPage.Priceperhour"
//                               className={invoiceCss.Text}
//                             />
//                             <span className={invoiceCss.No}>
//                               {formatMoney(
//                                 intl,
//                                 new Money(
//                                   invoiceDetails.listing.attributes.price.amount,
//                                   invoiceDetails.listing.attributes.price.currency
//                                 )
//                               )}
//                             </span>
//                           </span>

//                           <div className={invoiceCss.hourDiv}>
//                             <div className={invoiceCss.workPerDay}>
//                               <FormattedMessage id="SearchPage.workPerDay" />
//                               &nbsp;
//                               <b>
//                                 {formatHour(
//                                   moment(invoiceDetails.timestatement.endDate).diff(
//                                     invoiceDetails.timestatement.startDate,
//                                     'minute'
//                                   ) / 60,
//                                   userNativeLang,
//                                   true
//                                 )}
//                               </b>
//                               {invoiceDetails.timestatement.totalBreakTime > 0 ? (
//                                 <>
//                                   &nbsp;-&nbsp;
//                                   <FormattedMessage id="SearchPage.unpaidBreak" />
//                                   {': '}
//                                   &nbsp;
//                                   <b>
//                                     {formatHour(
//                                       invoiceDetails.timestatement.totalBreakTime /
//                                         invoiceDetails.timestatement.attendance.length,
//                                       userNativeLang,
//                                       true
//                                     )}
//                                   </b>
//                                 </>
//                               ) : null}
//                               &nbsp; &nbsp;
//                               <FormattedMessage id="SearchPage.Days" />
//                               {': '}
//                               <b>
//                                 {invoiceDetails.timestatement.attendance.length > 1 ? (
//                                   <React.Fragment>
//                                     {' '}
//                                     {formatDate(
//                                       invoiceDetails.listing.attributes.publicData.djobStartDate
//                                     )}{' '}
//                                     -{' '}
//                                     {formatDate(
//                                       invoiceDetails.listing.attributes.publicData.djobEndDate
//                                     )}
//                                   </React.Fragment>
//                                 ) : (
//                                   <React.Fragment>
//                                     {' '}
//                                     {formatDate(
//                                       invoiceDetails.listing.attributes.publicData.djobStartDate
//                                     )}
//                                   </React.Fragment>
//                                 )}
//                               </b>
//                             </div>

//                             <div className={invoiceCss.scheduleDiv}>
//                               <div className={invoiceCss.workerCountDiv}>
//                                 {' '}
//                                 <span>
//                                   <FormattedMessage id="FieldDateTimeInput.startTime" /> :
//                                 </span>
//                                 <span>
//                                   {invoiceDetails.listing.attributes.publicData.djobStartTime}{' '}
//                                   &nbsp;- &nbsp;
//                                 </span>{' '}
//                                 <span>
//                                   <FormattedMessage id="FieldDateTimeInput.endTime" /> :
//                                 </span>
//                                 <span>
//                                   {invoiceDetails.listing.attributes.publicData.djobEndTime}
//                                 </span>{' '}
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                         <div className={invoiceCss.hr}></div>
//                         <div className={invoiceCss.PriceBreakDownContainer}>
//                           {invoiceDetails.timestatement.attendance.map((data, indx) => (
//                             <div className={invoiceCss.DataDiv} key={indx}>
//                               <span className={invoiceCss.Text}>
//                                 {intl.formatMessage(
//                                   { id: 'Invoice.workerAmountPerDay' },
//                                   {
//                                     hour: data.totalWorkingHour,
//                                     date: formatDate(data.attendanceStartDate),
//                                   }
//                                 )}
//                               </span>
//                               <span className={invoiceCss.No}>
//                                 {formatMoney(
//                                   intl,
//                                   new Money(
//                                     invoiceDetails.listing.attributes.price.amount *
//                                       data.totalWorkingHour,
//                                     invoiceDetails.listing.attributes.price.currency
//                                   )
//                                 )}
//                               </span>
//                             </div>
//                           ))}

//                           {/* </div> */}
//                         </div>
//                         <div className={invoiceCss.hr}></div>

//                         <div className={invoiceCss.DataDivTotalAmount}>
//                           <span className={invoiceCss.Text}>
//                             <FormattedMessage id="Invoice.TotalAmount" />
//                           </span>

//                           <span className={invoiceCss.No}>
//                             {formatMoney(
//                               intl,
//                               new Money(
//                                 invoiceDetails.timestatement.finalPayment *
//                                   unitDivisor(config.currency),
//                                 config.currency
//                               )
//                             )}
//                           </span>
//                         </div>
//                       </div>
//                     </div>
